<template>
  <div>
    <!-- <div>
        <Breadcrumbs main="" title="My Profile" />
        <b-col class="text-right mt-1 pr-3 hideMonitorBtn">
            <add-monitor-button />
        </b-col>
    </div> -->
    <div>
      <div class="row">
        <div class="col-md-12">
          <div class="cust-padding">
            <!-- Profile Info Section -->
            <div class="profile-info-container">
              <div class="profile-header">
                <div class="profile-user-info">
                  <h2 class="profile-greeting">Hi {{ username }}!</h2>
                  <div class="profile-email-row">
                    <span class="profile-email">{{ email }}</span>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1Z" fill="#0062CC"/>
                      <path d="M11.5 5.5L6.5 10.5L4.5 8.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                </div>
                <div class="profile-status">
                  <span class="status-label">Activated</span>
                </div>
              </div>
              
              <div class="profile-divider"></div>
              
              <div class="profile-stats">
                <div class="stat-card">
                  <h3 class="stat-value">{{ userPlan }}</h3>
                  <p class="stat-label">Current Plan</p>
                </div>
                
                <div class="stat-card">
                  <h3 class="stat-value">{{ nextBillingDate }}</h3>
                  <p class="stat-label">Next Billing Date</p>
                </div>
                
                <div class="stat-card">
                  <h3 class="stat-value">{{ monitorsCount }}/{{ monitorsLimit }}</h3>
                  <p class="stat-label">Monitors</p>
                </div>
              </div>
            </div>
            
            <!-- Contact Information Section -->
            <div class="contact-info-container">
              <div class="contact-info-header">
                <h2 class="contact-info-title">Contact Information</h2>
                <button class="contact-edit-btn" @click="onEditContact" v-if="!contactEditMode">
                  <img src="@/assets/icons/Edit-icon.svg" alt="Edit" />
                  Edit
                </button>
              </div>
              <hr class="contact-divider" />
              <div class="contact-fields-row">
                <div class="contact-field-col">
                  <label class="contact-label">Name</label>
                  <div class="contact-input-wrapper">
                    <img src="@/assets/icons/name-icon.svg" class="contact-input-icon" alt="Name" />
                    <input type="text" v-model="contactName" :disabled="!contactEditMode" class="contact-input" placeholder="Enter your name" />
                  </div>
                </div>
                <div class="contact-field-col">
                  <label class="contact-label">Primary mail</label>
                  <div class="contact-input-wrapper">
                    <img src="@/assets/icons/email-icon.svg" class="contact-input-icon" alt="Email" />
                    <input type="email" v-model="contactEmail" :disabled="true" class="contact-input" placeholder="Enter mail" />
                  </div>
                  <div class="contact-field-desc">This e-mail is used to login, get alert notifications and reports.</div>
                </div>
              </div>
              <div class="contact-actions-row" v-if="contactEditMode">
                <button class="contact-action-btn" :disabled="!canSaveContact" @click="onUpdatePassword">Update Password</button>
                <button class="contact-action-btn" :disabled="!canSaveContact" @click="onSaveContact">Save & Logout</button>
              </div>
            </div>

            <!-- Change Password Section -->
            <div class="change-password-container" v-if="showChangePassword">
              <div class="change-password-header">
                <h2 class="change-password-title">Change password</h2>
                <button class="password-toggle-btn" @click="togglePasswordSection">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 10L12 15L17 10" stroke="#3A3A3A" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
              </div>
              <hr class="password-divider" />
              
              <!-- Current Password -->
              <div class="password-field">
                <label class="password-label">Current password *</label>
                <div class="password-input-wrapper">
                  <img src="@/assets/images/icons/lock-icon.svg" class="password-input-icon" alt="Lock" />
                  <input 
                    :type="showCurrentPassword ? 'text' : 'password'" 
                    v-model="currentPassword" 
                    class="password-input" 
                    placeholder="Enter current password"
                  />
                  <button type="button" class="password-visibility-btn" @click="toggleCurrentPassword">
                    <img v-if="showCurrentPassword" src="@/assets/fonts/feather/eye.svg" alt="Show" />
                    <img v-else src="@/assets/images/icons/eye-closed.svg" alt="Hide" />
                  </button>
                </div>
              </div>

              <!-- New and Confirm Password Row -->
              <div class="password-fields-row">
                <div class="password-field">
                  <label class="password-label">New Password *</label>
                  <div class="password-input-wrapper">
                    <img src="@/assets/images/icons/lock-icon.svg" class="password-input-icon" alt="Lock" />
                    <input 
                      :type="showNewPassword ? 'text' : 'password'" 
                      v-model="newPasswordInput" 
                      class="password-input" 
                      placeholder="Enter new password"
                    />
                    <button type="button" class="password-visibility-btn" @click="toggleNewPassword">
                      <img v-if="showNewPassword" src="@/assets/fonts/feather/eye.svg" alt="Show" />
                      <img v-else src="@/assets/images/icons/eye-closed.svg" alt="Hide" />
                    </button>
                  </div>
                </div>
                
                <div class="password-field">
                  <label class="password-label">Confirm password *</label>
                  <div class="password-input-wrapper">
                    <img src="@/assets/images/icons/lock-icon.svg" class="password-input-icon" alt="Lock" />
                    <input 
                      :type="showConfirmPassword ? 'text' : 'password'" 
                      v-model="confirmPassword" 
                      class="password-input" 
                      placeholder="Confirm new password"
                    />
                    <button type="button" class="password-visibility-btn" @click="toggleConfirmPassword">
                      <img v-if="showConfirmPassword" src="@/assets/fonts/feather/eye.svg" alt="Show" />
                      <img v-else src="@/assets/images/icons/eye-closed.svg" alt="Hide" />
                    </button>
                  </div>
                </div>
              </div>

              <!-- Password Actions -->
              <div class="password-actions-row">
                <button class="password-action-btn cancel" @click="cancelPasswordChange">Cancel</button>
                <button class="password-action-btn update" @click="onSubmit('password')" :disabled="!canUpdatePassword">Update Now</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import UserController from "../../services/userController";
import MonitorsController from "../../services/monitorController";
import UserAuth from "../auth/js/index";
import AddMonitorButton from "../components/addMonitorButton.vue";
export default {
  name: "Profile",
  components: { AddMonitorButton },
  data() {
    return {
      username: "",
      email: "",
      oldPassword: "",
      newPassword: "",
      repeatnewPassword: "",
      updatePassword: false,
      userinfo: {},
      fullname_err_text: "",
      userPlan: "Loading...",
      nextBillingDate: "Loading...",
      monitorsCount: 0,
      monitorsLimit: 0,
      contactEditMode: false,
      contactName: '',
      contactEmail: '',
      showChangePassword: false,
      currentPassword: '',
      newPasswordInput: '',
      confirmPassword: '',
      showCurrentPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,
    };
  },
  computed: {
    canSaveContact() {
      return this.contactName.trim() !== '' && this.contactEmail.trim() !== '';
    },
    canUpdatePassword() {
      // Update the actual password fields when checking validity
      if (this.currentPassword.trim() !== '' && 
          this.newPasswordInput.trim() !== '' && 
          this.confirmPassword.trim() !== '') {
        this.oldPassword = this.currentPassword;
        this.newPassword = this.newPasswordInput;
        this.repeatnewPassword = this.confirmPassword;
        return true;
      }
      return false;
    },
  },
  mounted() {
    this.userinfo = JSON.parse(localStorage.getItem("userinfo"));
    this.email = this.userinfo.email;
    this.username = this.userinfo.username;
    this.getPlanInfo();
    // Initialize contact fields from userinfo
    this.contactName = this.username;
    this.contactEmail = this.email;
  },
  methods: {
    async getPlanInfo() {
      try {
        const response = await UserController.getPlanInfo();
        if (response.result && response.message !== 'PLAN_NOT_FOUND') {
          const plan_details = response.message;
          this.userPlan = plan_details.plan_name || 'Free';
          this.monitorsLimit = plan_details.monitorcount || 0;
          
          // Get actual monitor count
          const monitorsResponse = await MonitorsController.getMonitors();
          if (monitorsResponse.result) {
            this.monitorsCount = monitorsResponse.data ? monitorsResponse.data.length : 0;
          }
          
          // Format next billing date using expiry_date (same as header.vue)
          if (plan_details.expiry_date && plan_details.plan_type !== 1) {
            const date = new Date(plan_details.expiry_date);
            const day = date.getDate();
            const month = date.toLocaleDateString('en-US', { month: 'short' });
            const year = date.getFullYear();
            this.nextBillingDate = `${day} ${month} ${year}`;
          } else {
            this.nextBillingDate = '-- --- ----';
          }
        } else {
          // Handle PLAN_NOT_FOUND case
          this.userPlan = 'No Plan';
          this.nextBillingDate = '-- --- ----';
          this.monitorsLimit = 0;
          this.monitorsCount = 0;
        }
      } catch (error) {
        console.error('Error fetching plan info:', error);
        this.userPlan = 'No Plan';
        this.nextBillingDate = '-- --- ----';
        this.monitorsLimit = 0;
        this.monitorsCount = 0;
      }
    },
    async onSubmit(txt) {
      var p = {};
      switch (txt) {
        case "username":
          if (this.validateFullName()) {
            p = { username: this.username };
          } else {
            this.$toasted.show(this.fullname_err_text, {
              theme: "outline",
              position: "bottom-center",
              type: "error",
              duration: 2000,
            });
            return;
          }
          break;
        case "email":
          if (this.validateEmail(this.email)) {
            p = { email: this.email };
          } else {
            this.$toasted.show("Invalid Email", {
              theme: "outline",
              position: "bottom-center",
              type: "error",
              duration: 2000,
            });
            return;
          }
          break;
        case "password":
          if (this.validatePassword()) {
            p = {
              oldPassword: this.oldPassword,
              newPassword: this.newPassword,
            };
          }
          break;
      }
      if (Object.keys(p).length > 0) {
        let response = await UserController.profile(p);
        if (response.result) {
          this.$toasted.show(response.message, {
            theme: "outline",
            position: "bottom-center",
            type: "success",
            duration: 2000,
          });
          // Clear password form before logout
          if (txt === 'password') {
            this.cancelPasswordChange();
          }
          UserAuth.Logout();
          this.$router.replace("/auth/login");
        } else {
          this.$toasted.show(response.message, {
            theme: "outline",
            position: "bottom-center",
            type: "error",
            duration: 2000,
          });
        }
      }
    },
    validatePassword() {
      if (this.oldPassword == "") {
        this.$toasted.show("Current Password is required", {
          theme: "outline",
          position: "bottom-center",
          type: "error",
          duration: 2000,
        });
        return false;
      } else if (this.newPassword == "") {
        this.$toasted.show("New Password is required", {
          theme: "outline",
          position: "bottom-center",
          type: "error",
          duration: 2000,
        });
        return false;
      } else if (this.repeatnewPassword == "") {
        this.$toasted.show("Repeat New Password is required", {
          theme: "outline",
          position: "bottom-center",
          type: "error",
          duration: 2000,
        });
        return false;
      } else if (this.oldPassword == this.newPassword) {
        this.$toasted.show(
          "Current Password and New Password should not be same",
          {
            theme: "outline",
            position: "bottom-center",
            type: "error",
            duration: 2000,
          }
        );
        return false;
      } else if (this.newPassword != this.repeatnewPassword) {
        this.$toasted.show(
          "New Password and Repeat New Password should be same",
          {
            theme: "outline",
            position: "bottom-center",
            type: "error",
            duration: 2000,
          }
        );
        return false;
      } else if (this.newPassword.length < 6) {
        this.$toasted.show("Password should be minimum 6 characters", {
          theme: "outline",
          position: "bottom-center",
          type: "error",
          duration: 2000,
        });
        return false;
      } else {
        return true;
      }
    },
    validateEmail(email) {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(email);
    },
    validateFullName() {
      var fullName = this.username;
      const regex = /^[a-zA-Z0-9 ]+$/; // Alphanumeric and space characters only
      if (!regex.test(fullName) && fullName != "") {
        this.username = "";
        this.fullname_err_text =
          "Full name can only contain alphanumeric characters and spaces";
        this.username = this.userinfo.username;
        return false;
      } else {
        return true;
      }
    },
    onEditContact() {
      this.contactEditMode = true;
    },
    onSaveContact() {
      // Update username from contact name
      this.username = this.contactName;
      // Call the existing submit method to save username
      this.onSubmit('username');
      // Exit edit mode to hide buttons
      this.contactEditMode = false;
    },
    onUpdatePassword() {
      // Show the change password section
      this.showChangePassword = true;
      // Hide contact edit mode
      this.contactEditMode = false;
      // Clear any previous password values
      this.oldPassword = '';
      this.newPassword = '';
      this.repeatnewPassword = '';
      this.currentPassword = '';
      this.newPasswordInput = '';
      this.confirmPassword = '';
    },
    togglePasswordSection() {
      this.showChangePassword = !this.showChangePassword;
    },
    toggleCurrentPassword() {
      this.showCurrentPassword = !this.showCurrentPassword;
    },
    toggleNewPassword() {
      this.showNewPassword = !this.showNewPassword;
    },
    toggleConfirmPassword() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },
    cancelPasswordChange() {
      // Clear password fields
      this.currentPassword = '';
      this.newPasswordInput = '';
      this.confirmPassword = '';
      // Hide password section
      this.showChangePassword = false;
      // Reset visibility states
      this.showCurrentPassword = false;
      this.showNewPassword = false;
      this.showConfirmPassword = false;
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
hr {
  margin-top: 0rem !important;
}

.cust-padding {
  padding: 1rem !important;
}

/* Profile Info Section */
.profile-info-container {
  background: #FFFFFF;
  border: 1px solid #D2E3FB;
  border-radius: 20px;
  padding: 30px;
  margin-bottom: 30px;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.profile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.profile-user-info {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.profile-greeting {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 26px;
  line-height: 1.5em;
  color: #3A3A3A;
  margin: 0;
}

.profile-email-row {
  display: flex;
  align-items: center;
  gap: 5px;
}

.profile-email {
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.5em;
  color: #3A3A3A;
}

.profile-status {
  background: rgba(47, 178, 52, 0.1);
  border-radius: 12px;
  padding: 8px 15px;
}

.status-label {
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 18px;
  line-height: 1.5em;
  letter-spacing: 0.011em;
  color: #188007;
}

.profile-divider {
  width: 100%;
  height: 1px;
  background: #D2E3FB;
}

.profile-stats {
  display: flex;
  justify-content: stretch;
  align-items: stretch;
  gap: 50px;
}

.stat-card {
  flex: 1;
  background: #FFFFFF;
  border: 1px solid #D2E3FB;
  border-radius: 20px;
  padding: 30px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
}


.stat-value {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 28px;
  line-height: 0.915em;
  color: #3A3A3A;
  margin: 0;
}

.stat-label {
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 20px;
  line-height: 0.915em;
  color: #3A3A3A;
  margin: 0;
}

/* Contact Information Section */
.contact-info-container {
  background: #FFFFFF;
  border: 1px solid #D2E3FB;
  border-radius: 20px;
  padding: 30px;
  margin-bottom: 30px;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
}
.contact-info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}
.contact-info-title {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 0.915em;
  color: #3A3A3A;
  margin: 0;
}
.contact-edit-btn {
  background: none;
  border: none;
  color: #3A3A3A;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 20px;
  line-height: 0.915em;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 0;
}
.contact-edit-btn img {
  width: 20px;
  height: 20px;
}
.contact-divider {
  border: none;
  border-top: 1px solid #D2E3FB;
  margin: 0 0 30px 0;
}
.contact-fields-row {
  display: flex;
  gap: 30px;
  margin-bottom: 30px;
}
.contact-field-col {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.contact-label {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 0.915em;
  color: #3A3A3A;
  margin-bottom: 0;
}
.contact-input-wrapper {
  display: flex;
  align-items: center;
  background: #FFFFFF;
  border: 1px solid #D2E3FB;
  border-radius: 12px;
  padding: 20px;
  height: 64px;
  gap: 10px;
}
.contact-input-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}
.contact-input {
  border: none;
  outline: none;
  background: transparent;
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  line-height: 0.915em;
  font-weight: 500;
  color: #3A3A3A;
  flex: 1;
  height: auto;
}
.contact-input::placeholder {
  color: #3A3A3A;
  opacity: 0.5;
}
.contact-input:disabled {
  color: #3A3A3A;
  background: transparent;
}
.contact-field-desc {
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 1.5em;
  color: #3A3A3A;
  margin-top: 0;
  margin-bottom: 0;
}
.contact-actions-row {
  display: flex;
  justify-content: flex-end;
  gap: 30px;
  margin-top: 30px;
}
.contact-action-btn {
  background: #2FB234;
  color: #FFFFFF;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 18px;
  line-height: 1.5em;
  border: none;
  border-radius: 12px;
  padding: 10px 20px;
  height: 48px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}
.contact-action-btn:hover:not(:disabled) {
  background: #7D8699;
  transform: translateY(-1px);
}
.contact-action-btn:disabled {
  background: #7D8699;
  opacity: 0.5;
  cursor: not-allowed;
}

/* Change Password Section */
.change-password-container {
  background: #FFFFFF;
  border: 1px solid #D2E3FB;
  border-radius: 20px;
  padding: 30px;
  margin-bottom: 30px;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.change-password-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.change-password-title {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 0.915em;
  color: #3A3A3A;
  margin: 0;
}

.password-toggle-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
}

.password-toggle-btn:hover {
  transform: rotate(180deg);
}

.password-divider {
  border: none;
  border-top: 1px solid #D2E3FB;
  margin: 0 0 30px 0;
}

.password-field {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 30px;
  flex: 1;
}

.password-fields-row {
  display: flex;
  gap: 30px;
  margin-bottom: 30px;
}

.password-fields-row .password-field {
  margin-bottom: 0;
}

.password-label {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 0.915em;
  color: #3A3A3A;
  margin-bottom: 0;
}

.password-input-wrapper {
  display: flex;
  align-items: center;
  background: #FFFFFF;
  border: 1px solid #D2E3FB;
  border-radius: 12px;
  padding: 20px;
  height: 64px;
  gap: 10px;
  position: relative;
}

.password-input-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.password-input {
  border: none;
  outline: none;
  background: transparent;
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  line-height: 0.915em;
  font-weight: 500;
  color: #3A3A3A;
  flex: 1;
  height: auto;
}

.password-input::placeholder {
  color: #3A3A3A;
  opacity: 0.5;
}

.password-visibility-btn {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}

.password-visibility-btn img {
  width: 24px;
  height: 24px;
}

.password-actions-row {
  display: flex;
  justify-content: flex-end;
  gap: 30px;
  margin-top: 30px;
}

.password-action-btn {
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 18px;
  line-height: 1.5em;
  border: none;
  border-radius: 12px;
  padding: 10px 20px;
  height: 48px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.password-action-btn.cancel {
  background: #7D8699;
  color: #FFFFFF;
}

.password-action-btn.cancel:hover {
  background: #6B7280;
  transform: translateY(-1px);
}

.password-action-btn.update {
  background: #2FB234;
  color: #FFFFFF;
}

.password-action-btn.update:hover:not(:disabled) {
  background: #28A02D;
  transform: translateY(-1px);
}

.password-action-btn.update:disabled {
  background: #2FB234;
  opacity: 0.5;
  cursor: not-allowed;
}

@media (max-width: 1200px) {
  .profile-info-container,
  .contact-info-container,
  .change-password-container {
    width: 100%;
  }
}

@media (max-width: 900px) {
  .contact-info-container,
  .change-password-container {
    padding: 20px 10px 16px 10px;
  }
  .contact-fields-row,
  .password-fields-row {
    flex-direction: column;
    gap: 20px;
  }
  .contact-action-btn,
  .password-action-btn {
    min-width: 120px;
    font-size: 16px;
    padding: 12px 18px;
  }
}

@media screen and (max-width: 768px) {
  .cust-padding {
    padding: 2rem !important;
  }

  .custom-card-shadow {
    margin-bottom: 2rem !important;
  }

  .profile-info-container {
    padding: 20px;
    gap: 20px;
  }

  .profile-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .profile-greeting {
    font-size: 22px;
  }

  .profile-email {
    font-size: 14px;
  }

  .status-label {
    font-size: 16px;
  }

  .profile-stats {
    flex-direction: column;
    gap: 20px;
  }

  .stat-card {
    padding: 20px;
    gap: 20px;
  }

  .stat-value {
    font-size: 24px;
  }

  .stat-label {
    font-size: 16px;
  }
}
</style>